import { JsonObject, JsonProperty } from 'json2typescript';
import { NewsPredefinedTranslation } from './news-predefined-translation.model';

@JsonObject('NewsPredefined')
export class NewsPredefined {

  @JsonProperty('news_predefined_id', Number)
  newsPredefinedId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('translations', [NewsPredefinedTranslation])
  translations: NewsPredefinedTranslation[] = [];
}
